<ng-container *ngIf="tagCategory.multiselectable">
    <div class="mb-0050">
        <h2 class="mb-0075">Add Response for {{tagCategory.name}}</h2>
        <div class="row flexWrap--nowrap row--sep-if-stacked">
            <app-apply-tag-multi-form class="col"
                                      [campaignId]="campaignId"
                                      [tagCategory]="tagCategory"
                                      [formArray]="tagsFormArray"
                                      [isAdvancedResponseSelector]="true"></app-apply-tag-multi-form>

            <!-- Removes a tag to apply only when there is more than 1 tag selected-->
        </div>
    </div>

    <div class="dual-btn-row flex flexJustify--between pb-0025 mt-0100">
        <button mat-button
                [disabled]="tagsFormArray.invalid || isSaving"
                class="btn"
                [appButtonSpinner]="isSaving"
                (click)="onSaveClick()">Save</button>
    </div>
</ng-container>

<ng-container *ngIf="!tagCategory.multiselectable">
    <div class="mb-0050">
        <h2 class="mb-0075">Add Response for {{tagCategory.name}}</h2>
        <div class="row flexWrap--nowrap row--sep-if-stacked"
             *ngFor="let control of tagsFormArray.controls; index as i">
            <app-apply-tag-form [campaignId]="campaignId"
                                tabindex="1"
                                class="col"
                                [tagCategory]="tagCategory"
                                [formControl]="tagsFormArray.controls[i]"
                                [ngClass]="{'col--gutter': tagsFormArray.controls.length > 1}"></app-apply-tag-form>

        </div>
    </div>

    <div class="dual-btn-row flex flexJustify--between pb-0025 mt-0100">
        <button mat-button
                [disabled]="tagsFormArray.invalid || isSaving"
                class="btn"
                [appButtonSpinner]="isSaving"
                (click)="onSaveClick()">Save</button>
    </div>
</ng-container>
